import { ContractorUserRole } from "types/ContractorUserEnum"

import { RadioButton } from "components/form/RadioButton"

import { RoleContainer, RoleDescription, RoleHeader, RoleTitle } from "./styled"

interface Props {
  selectedRole: ContractorUserRole | undefined
  onChange: (value: ContractorUserRole) => void
}

const ContractorRoleSelect = ({ selectedRole, onChange }: Props) => {
  return (
    <>
      <RoleHeader>Role</RoleHeader>
      <div>
        <RoleContainer>
          <div>
            <RoleTitle>Admin</RoleTitle>
            <RoleDescription>Full access</RoleDescription>
          </div>
          <RadioButton
            id={"contractor-admin"}
            name="contractor-role"
            isChecked={selectedRole === ContractorUserRole.ADMIN}
            onChange={() => onChange(ContractorUserRole.ADMIN)}
            value={ContractorUserRole.ADMIN}
          />
        </RoleContainer>
        <RoleContainer>
          <div>
            <RoleTitle>Manager</RoleTitle>
            <RoleDescription>Full access to all features except user management (create/edit).</RoleDescription>
          </div>
          <RadioButton
            id={"contractor-manager"}
            name="contractor-role"
            isChecked={selectedRole === ContractorUserRole.MANAGER}
            onChange={() => onChange(ContractorUserRole.MANAGER)}
            value={ContractorUserRole.MANAGER}
          />
        </RoleContainer>
        <RoleContainer>
          <div>
            <RoleTitle>Technician</RoleTitle>
            <RoleDescription>
              Can manage customer data, run performance tests, access Thermostat monitoring data and alerts also get AI
              generated intelligence (performance) reports
            </RoleDescription>
          </div>
          <RadioButton
            id={"contractor-technician"}
            name="contractor-role"
            isChecked={selectedRole === ContractorUserRole.TECHNICIAN}
            onChange={() => onChange(ContractorUserRole.TECHNICIAN)}
            value={ContractorUserRole.TECHNICIAN}
          />
        </RoleContainer>
      </div>
    </>
  )
}

export default ContractorRoleSelect
